export const MainServicesArray = [
  {
    label: 'Online Sessions',
    description: 'Experience domination from anywhere with my exclusive online sessions.',
  },
  {
    label: 'Domination',
    description: 'Intense and personalized BDSM sessions tailored to your deepest desires.',
  },
  {
    label: 'Fansites',
    description: 'Exclusive content and interactions on my premium fan platforms.',
  },
  {
    label: 'Keyholding',
    description: 'Long-term control and chastity keyholding services for the truly devoted.',
  },
  {
    label: 'Fetish Pictures',
    description: 'Custom Fetish Picture Collection available at request.',
  },
  {
    label: 'Custom Requests',
    description: 'Bespoke experiences and personalized domination tailored to your needs.',
  },
];
